import NotFoundView from '@/components/error/404.vue'
import Agentmanagement from '@/components/view/Agentmanagement/main.vue'
import Account from '@/components/view/allbots/Account'
import Billing from '@/components/view/billing/Billing'
import Upgrade from '@/components/view/billing/Upgrade'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Chat from '@/components/view/chat/Chat'
import SetupC2p from '@/components/view/chat2pay/SetupC2p'
import Dashboard from '@/components/view/dashboard/Dashboard'
import Export from '@/components/view/Export/Export'
import GetCurrentLocation from '@/components/view/GetCurrentLocation.vue'
import Setup from '@/components/view/getstarted/Setup'
import Comment from '@/components/view/intent/CommentToInbox'
import Conversation from '@/components/view/intent/Conversation'
import Training from '@/components/view/intent/Training'
import Live from '@/components/view/live/Main'
import LivechatView from '@/components/view/livechat/LivechatView'
import PBlog from '@/components/view/partner/Blog'
import PCustomer from '@/components/view/partner/Customer'
import PProfile from '@/components/view/partner/Profile'
import PRedeemCode from '@/components/view/partner/RedeemCode'
import RedeemCode from '@/components/view/redeem/redeemcode.vue'
import OrderSummaryLine from '@/components/view/template/ecommerce/OrderSummaryLine'
import Template from '@/components/view/template/template'
import Ticket from '@/components/view/template/ticket/main.vue'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'
import TTBProfile from '@/features/ttb/Profile'
import TTBDashboardNonvoice from '@/features/ttb/DashboardNonvoice'
import TTBDashboardNonvoiceOverview from '@/features/ttb/DashboardNonvoice/Overview'
import TTBDashboardNonvoiceAgents from '@/features/ttb/DashboardNonvoice/Agents'
import TTBDashboardNonvoiceAgentsPerformanceSummary from '@/features/ttb/DashboardNonvoice/Agents/Summary'
import TTBDashboardNonvoiceAgentsPerformance from '@/features/ttb/DashboardNonvoice/Agents/Performance'
import TTBDashboardNonvoiceAgentsWorkTime from '@/features/ttb/DashboardNonvoice/Agents/WorkTime'
import TTBDashboardNonvoiceReplyComment from '@/features/ttb/DashboardNonvoice/ReplyComment'
import TTBDashboardNonvoiceSurvey from '@/features/ttb/DashboardNonvoice/Survey'
import TTBDashboardNonvoiceReport from '@/features/ttb/DashboardNonvoice/Report'

import { store } from '@/store/store'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/view/linenotify/Linenotify.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connectline',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/login/ConnectLine.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connect_quality',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/view/linenotify/Prepare.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: function (resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'login',
        name: 'login',
        component: function (resolve) {
          require(['@/components/login/Login.vue'], resolve)
        }
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: function (resolve) {
          require(['@/components/login/Chat2Pay.vue'], resolve)
        },
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'ordersummary',
        name: 'ordersummary',
        component: OrderSummaryLine,
        meta: {
          title: 'Order Summary'
        }
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
        meta: {
          title: 'Chat'
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        }
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversations'
        }
      },
      {
        path: 'allinonechat',
        name: 'allinonechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        }
      },
      {
        path: 'getcurrentlocation',
        name: 'getcurrentlocation',
        component: GetCurrentLocation
      },
      {
        path: 'ticket',
        name: 'ticket',
        component: Ticket,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        }
      },
      {
        path: 'billing',
        name: 'setting',
        component: Billing,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        }
      },
      {
        path: 'training',
        name: 'Training',
        component: Training,
        beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        }
      },
      {
        path: 'setup_c2p',
        name: 'setup_c2p',
        component: SetupC2p,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setup Chat2Pay'
        }
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        }
      },
      {
        path: 'RedeemCode',
        name: 'RedeemCode',
        component: RedeemCode,
        beforeEnter: guardRoute,
        meta: {
          title: 'Redeem Code'
        }
      },
      {
        path: 'live',
        name: 'live',
        component: Live,
        beforeEnter: guardRoute,
        meta: {
          title: 'Live'
        }
      },

      {
        path: 'agentmanagement',
        name: 'AgentManagement',
        component: Agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },

      {
        path: 'partner',
        component: {
          name: 'partner',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'profile'
          },
          {
            path: 'profile',
            name: 'profile',
            component: PProfile,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Profile'
            }
          },
          {
            path: 'blog',
            name: 'blog',
            component: PBlog,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Blog'
            }
          },
          {
            path: 'redeemcode',
            name: 'redeemcode',
            component: PRedeemCode,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Redeem Code'
            }
          },
          {
            path: 'customer',
            name: 'customer',
            component: PCustomer,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Customer'
            }
          }
        ]
      },
      {
        path: 'export',
        name: 'export',
        component: Export,
        beforeEnter: guardRoute,
        meta: {
          title: 'Export'
        }
      },
      {
        path: 'ttb',
        component: {
          name: 'ttb',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'profile',
            name: 'ttb-profile',
            component: TTBProfile,
            beforeEnter: guardRoute,
            meta: {
              title: 'Profile'
            }
          },
          {
            path: 'dashboard-nonvoice',
            name: 'ttb-dashboard-nonvoice',
            redirect: {
              name: 'ttb-dashboard-nonvoice-overview'
            },
            component: TTBDashboardNonvoice,
            beforeEnter: guardRoute,
            meta: {
              title: 'Dashboard Nonvoice'
            },
            children: [
              {
                path: 'overview',
                name: 'ttb-dashboard-nonvoice-overview',
                component: TTBDashboardNonvoiceOverview,
                beforeEnter: guardRoute,
                meta: {
                  title: 'Dashboard Nonvoice: Overview'
                }
              },
              {
                path: 'agents',
                name: 'ttb-dashboard-nonvoice-agents',
                redirect: {
                  name: 'ttb-dashboard-nonvoice-agents-performance-summary'
                },
                component: TTBDashboardNonvoiceAgents,
                beforeEnter: guardRoute,
                meta: {
                  title: 'Dashboard Nonvoice: Agents'
                },
                children: [
                  {
                    path: 'performance-summary',
                    name: 'ttb-dashboard-nonvoice-agents-performance-summary',
                    component: TTBDashboardNonvoiceAgentsPerformanceSummary,
                    beforeEnter: guardRoute,
                    meta: {
                      title: 'Dashboard Nonvoice: Agent Performance Summary'
                    }
                  },
                  {
                    path: 'performance',
                    name: 'ttb-dashboard-nonvoice-agents-performance',
                    component: TTBDashboardNonvoiceAgentsPerformance,
                    beforeEnter: guardRoute,
                    meta: {
                      title: 'Dashboard Nonvoice: Agent Performance'
                    }
                  },
                  {
                    path: 'work-time',
                    name: 'ttb-dashboard-nonvoice-agents-work-time',
                    component: TTBDashboardNonvoiceAgentsWorkTime,
                    beforeEnter: guardRoute,
                    meta: {
                      title: 'Dashboard Nonvoice: Agent Work Time'
                    }
                  }
                ]
              },
              {
                path: 'reply-comment',
                name: 'ttb-dashboard-nonvoice-reply-comment',
                component: TTBDashboardNonvoiceReplyComment,
                beforeEnter: guardRoute,
                meta: {
                  title: 'Dashboard Nonvoice: Reply Comment'
                }
              },
              {
                path: 'survey',
                name: 'ttb-dashboard-nonvoice-survey',
                component: TTBDashboardNonvoiceSurvey,
                beforeEnter: guardRoute,
                meta: {
                  title: 'Dashboard Nonvoice: Survey'
                }
              },
              {
                path: 'report',
                name: 'ttb-dashboard-nonvoice-report',
                component: TTBDashboardNonvoiceReport,
                beforeEnter: guardRoute,
                meta: {
                  title: 'Dashboard Nonvoice: Report'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'agent-management',
        name: 'agent-management',
        component: Agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },

      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (to.name == 'dashboard' && to.query && to.query.tab == 'ceemeagain') {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { tab: 'ceemeagain' }
      })
      return
    }
  }
  var query = { ...to.query }
  query.redirect = to.fullPath

  if (!store.getters.isLoggedIn) {
    if (to.query.usertype == 'nigol') {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function (response) {
            // checkTokenStatus(next)
            next()
          },
          function (e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function (response) {
            // checkTokenStatus(next)
            next()
          },
          function (e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }

      next()
    }
  }
}

function guardPartnerRoute(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/nigol',
      query: { redirect: to.fullPath, utm_source: to.query.utm_source }
    })
  } else {
    if (store.state.partner_code) {
      next()
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js